export const snStateMap = new Map([
  [10, { label: '已生成', tag: '' }],
  [20, { label: '已烧录', tag: 'success' }],
  [21, { label: '烧录中', tag: 'info' }],
  [22, { label: '烧录失败', tag: 'danger' }],
  [23, { label: '烧录异常', tag: 'danger' }],
  [30, { label: '已激活', tag: 'warning' }]
])

export const snOperationMap = new Map([
  [10, { label: '生成', tag: '' }],
  [20, { label: '烧录', tag: 'success' }],
  [21, { label: '请求烧录指令', tag: 'info' }],
  [30, { label: '激活', tag: 'warning' }],
  [40, { label: '反激活', tag: '' }]
])
